import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
    Accordion, Grid, Icon, List,
} from "semantic-ui-react";

import { RootState } from "../../../redux/store";
import { DesignState } from "../../../states/design";
import Price from "../Price";


/**
 * @param variantId - Unique id of the variant
 * @returns Component to list the currently selected specifications of a variant.
 */
export default function SpecificationsShow (props: { variantId: string }): React.ReactElement {
    const variant = useSelector((state: RootState) => state.variants[props.variantId]);
    const design: DesignState | undefined = useSelector((state: RootState) => {
        return Object.values(state.designs).find(design => design.id === variant.designId);
    });

    const [ customerNoteCollapsed, setCustomerNoteCollapsed ] = useState(true);

    const [ t ] = useTranslation();

    if (!design) {
        return (<></>);
    }


    if (!variant) {
        return (<></>);
    }

    return (
        <>
            <Grid
                style={{ wordWrap: "anywhere", overflowWrap: "anywhere" }}
            >
                <Grid.Row columns={2}>
                    <Grid.Column
                        width={10}
                    >
                        <List>
                            <List.Item>
                                <List.Content>
                                    <List.Header>{t("variants:specifications.show.title")}</List.Header>
                                </List.Content>
                            </List.Item>
                            <List.Item>{t("variants:specifications.fieldTitles.procedure")}: {t(`printOptions:procedures.${ variant.printOptions.procedure }.alias`)}</List.Item>
                            <List.Item>{t("variants:specifications.fieldTitles.material")}: {t(`printOptions:materials.${ variant.printOptions.material }.alias`)}</List.Item>
                            <List.Item>{t("variants:specifications.fieldTitles.color")}: {t(`printOptions:colors.${ variant.printOptions.colorId }.alias`)}</List.Item>
                            { variant.printOptions.procedure === "sla" ? <></> :
                                <List.Item>{t("variants:specifications.fieldTitles.infill")}: {`${ variant.printOptions.infill } %`}</List.Item>
                            }
                            <List.Item>{t("variants:specifications.fieldTitles.quantity")}: {variant.quantity}</List.Item>
                        </List>
                    </Grid.Column>

                    <Grid.Column
                        width={6}
                        textAlign="right"
                        floated="right"
                    >
                        <span
                            style={{ fontWeight: "bold" }}
                        >
                            <Price

                                variantId={variant.id}
                                showQuantity={false}
                                totalPrice={true}
                            />
                        </span>
                        <br/>
                        <Price
                            variantId={variant.id}
                            showQuantity={false}
                            totalPrice={false}
                        /> / {t("variants:specifications.show.piece")}
                    </Grid.Column>
                </Grid.Row>

                {variant.customerNote ?
                    <Grid.Row columns={1}>
                        <Grid.Column
                            style={{ wordWrap: "anywhere", overflowWrap: "anywhere" }}
                        >
                            <Accordion
                                fliud
                            >
                                <Accordion.Title
                                    index={0}
                                    active={!customerNoteCollapsed}
                                    onClick={(): void => setCustomerNoteCollapsed(!customerNoteCollapsed)}
                                >
                                    <Icon name='dropdown' />
                                    {t("variants:notes.customerRemark")}
                                </Accordion.Title>
                                <Accordion.Content
                                    active={!customerNoteCollapsed}
                                >
                                    <p>
                                        {variant.customerNote}
                                    </p>
                                </Accordion.Content>
                            </Accordion>
                        </Grid.Column>
                    </Grid.Row> :
                    <></>
                }
            </Grid>
        </>
    );
}
